import PoojaTadwai from './PoojaTadwai';

function App() {
  return <PoojaTadwai />;
}

export default App;
